import ES from './es';
import EN from './en';

const expirations = {
    ES,
    EN
};

export default expirations;
